module.exports = __webpack_public_path__ + "img/an.e48ec511.png";